import React, { useEffect, useState} from 'react'
import Layout from '../layout/Layout'
import Item from '../components/Folder/Item';
import AddBtn from '../components/AddBtn';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import secureApi from '../helpers/secureApi';
import {DocInterface} from '../interfaces/docInterface';

export default function Folder() {

    const navigate = useNavigate();
    const {folderId} = useParams();
    const [folderData, setFolderData] = useState<DocInterface[] | null>(null);

    useEffect(()=>{
        if(folderId){
            axios.get(secureApi('get-docs-by-folder-id/'+folderId))
            .then(response=>{
                console.log("response2", response);
                if(response?.data?.type=='success' && response?.data?.docs){
                    setFolderData(response?.data?.docs);
                }
            })
            .catch(e=> console.log("get-folder-by-id error", e));
        }
    }, [folderId]);

  return (
    <Layout>
        <AddBtn name="Doc +" onClickFn={()=>navigate('/add-doc/'+folderId)} />
        <div className='docs'>
        {
            folderData ? 
            (folderData.map((data)=>{
                return <Item {...data} key={data?.id} />
            }))
            :
            <></>
        }
        </div>
    </Layout>
  )
}
